import { Button } from 'antd';
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { FileTextOutlined } from '@ant-design/icons';

type Section = {
  title: string;
  headers: string[];
  rows: Record<string, any>[];
};

interface DownloadProps {
  fileName: string;
  sections: Section[];
  btnText?: string;
}

const MultiTableExcel = ({ fileName, sections, btnText = 'Excel Report' }: DownloadProps) => {
  const saveExcel = async () => {
    try {
      const wb = new Excel.Workbook();
      const ws = wb.addWorksheet('Report');

      let nextRow = 1;

      sections.forEach(({ title, headers, rows }, idx) => {
        /* ----- Title row ----- */
        const titleRow = ws.addRow([title]);
        titleRow.font = { bold: true, size: 14 };
        titleRow.alignment = { horizontal: 'center' };
        ws.mergeCells(`A${nextRow}:${String.fromCharCode(65 + headers.length - 1)}${nextRow}`);

        /* ----- Header row ----- */
        const headerRow = ws.addRow(headers);
        headerRow.eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: 'center' };
        });
        /* Column widths */
        ws.columns.forEach((col) => (col.width = 25));

        /* ----- Data rows ----- */
        rows.forEach((r) => {
          const row = ws.addRow(headers.map((h) => r[h]));
          row.height = 25;
          row.eachCell((c) => {
            c.alignment = { vertical: 'middle', horizontal: 'left' };
          });
        });

        /* Leave one blank row before the next section (except after the last) */
        nextRow = ws.lastRow!.number + 2;
        if (idx < sections.length - 1) ws.addRow([]); // the actual blank row
      });

      const buffer = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), `${fileName}.xlsx`);
    } catch (err: any) {
      console.error('Excel generation failed:', err.message);
    }
  };

  return (
    <Button type='primary' icon={<FileTextOutlined />} onClick={saveExcel}>
      {btnText}
    </Button>
  );
};

export default MultiTableExcel;
